import React from 'react';
import { twMerge } from 'tailwind-merge';
import '../../utils/Flows';
import { Message, XIcon } from '../../../SVG';
import { MobileStates, WidgetStateChangeType, WidgetStates } from '../Widget';
import { useRingStyle } from '../../../tailwind_common/util';
import { getIntialStateIsHidden } from '../../utils/Params';
export var LaunchButton = function (props) {
    var widgetState = props.widgetState, setWidgetState = props.setWidgetState, setWorkflow = props.setWorkflow, mobileState = props.mobileState;
    var ringStyle = useRingStyle();
    var initialState = getIntialStateIsHidden(mobileState)
        ? WidgetStates.HIDDEN
        : WidgetStates.COLLAPSED;
    var handleClick = function () {
        if (widgetState === WidgetStates.EXPANDED) {
            setWidgetState(initialState, WidgetStateChangeType.MANUAL);
            setWorkflow(null, WidgetStateChangeType.MANUAL);
        }
        else {
            setWidgetState(WidgetStates.EXPANDED, WidgetStateChangeType.MANUAL);
        }
    };
    return (React.createElement("button", { className: twMerge('tw-focus absolute bottom-0 right-0 flex h-[60px] w-[60px] items-center justify-center rounded-full border border-2 border-solid border-widget-gray bg-primary shadow-widget-launch-button transition-all duration-300 hover:scale-110 hover:transform', mobileState === MobileStates.MOBILE &&
            widgetState === WidgetStates.EXPANDED &&
            'h-0 w-0 border-0'), onClick: handleClick, style: ringStyle }, widgetState === WidgetStates.COLLAPSED || widgetState === WidgetStates.HIDDEN ? (React.createElement(Message, null)) : (React.createElement(XIcon, { width: 20, height: 20 }))));
};
export default LaunchButton;
